import { t } from "@lingui/macro";
import { useState } from "react";
import { Platform } from "react-native";

import { ToggleSwitch } from "@whoosh/design-system/src/components/controls";
import { LockIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { useBiometricUnlock } from "../../../../features/BiometricAuthentication";
import { getBiometricUnlockLabel } from "../../../../features/BiometricAuthentication/getBiometricUnlockCopy";

type BiometricUnlockSettingProps = {
  userId?: string;
};

export const BiometricUnlockSetting = ({
  userId,
}: BiometricUnlockSettingProps) => {
  const [toggleVersion, setToggleVersion] = useState(0);
  const {
    errorMessage,
    isAvailable,
    isEnabled,
    isLoading,
    setEnabled,
    type: biometricUnlockType,
  } = useBiometricUnlock(userId);

  if (Platform.OS === "web" || !isAvailable) {
    return null;
  }

  const biometricUnlockLabel = getBiometricUnlockLabel(
    Platform.OS,
    biometricUnlockType
  );

  return (
    <Box gap={2} mt={4}>
      <Text variant="mainSmallSemiBold">{t`Security`}</Text>
      <HStack gap={4} py={4} alignItems="center">
        <Box p={3} bg="surface-secondary" borderRadius="2">
          <LockIcon />
        </Box>
        <Text flexGrow={1} variant="mainBaseMedium">
          {biometricUnlockLabel}
        </Text>
        <ToggleSwitch
          key={`${isEnabled}-${toggleVersion}`}
          isChecked={isEnabled}
          isDisabled={isLoading}
          onToggle={(nextValue) => {
            void setEnabled(nextValue).then((wasEnabled) => {
              if (!wasEnabled) {
                setToggleVersion((version) => version + 1);
              }
            });
          }}
          accessibilityLabel={biometricUnlockLabel}
          testID="biometric-unlock-toggle"
        />
      </HStack>
      {errorMessage ? (
        <Text variant="mainSmallMedium">{errorMessage}</Text>
      ) : null}
    </Box>
  );
};
